/**
 * podravka.io
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.7.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import ArticleState from '../model/ArticleState';
import ArticleStateUpdate from '../model/ArticleStateUpdate';
import BadRequestError from '../model/BadRequestError';
import BrandState from '../model/BrandState';
import BrandStateUpdate from '../model/BrandStateUpdate';
import FileState from '../model/FileState';
import FileStateUpdate from '../model/FileStateUpdate';
import ForbiddenError from '../model/ForbiddenError';
import ImageState from '../model/ImageState';
import ImageStateUpdate from '../model/ImageStateUpdate';
import IngredientState from '../model/IngredientState';
import IngredientStateUpdate from '../model/IngredientStateUpdate';
import NotAcceptableError from '../model/NotAcceptableError';
import NotFoundError from '../model/NotFoundError';
import ProductState from '../model/ProductState';
import ProductStateUpdate from '../model/ProductStateUpdate';
import RecipeState from '../model/RecipeState';
import RecipeStateUpdate from '../model/RecipeStateUpdate';
import TaxonState from '../model/TaxonState';
import TaxonStateUpdate from '../model/TaxonStateUpdate';
import UnauthorizedError from '../model/UnauthorizedError';
import VideoState from '../model/VideoState';
import VideoStateUpdate from '../model/VideoStateUpdate';

/**
* State service.
* @module api/StateApi
* @version 1.7.2
*/
export default class StateApi {

    /**
    * Constructs a new StateApi. 
    * @alias module:api/StateApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the getArticleState operation.
     * @callback module:api/StateApi~getArticleStateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ArticleState} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the state of Article resource.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} id 
     * @param {module:api/StateApi~getArticleStateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ArticleState}
     */
    getArticleState(acceptLanguage, id, callback) {
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getArticleState");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getArticleState");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = ArticleState;
      return this.apiClient.callApi(
        '/articles/{id}/state', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getBrandState operation.
     * @callback module:api/StateApi~getBrandStateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BrandState} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the state of Brand resource.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} id 
     * @param {module:api/StateApi~getBrandStateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BrandState}
     */
    getBrandState(acceptLanguage, id, callback) {
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getBrandState");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getBrandState");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = BrandState;
      return this.apiClient.callApi(
        '/brands/{id}/state', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getFileState operation.
     * @callback module:api/StateApi~getFileStateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/FileState} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the state of File resource.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} id 
     * @param {module:api/StateApi~getFileStateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/FileState}
     */
    getFileState(acceptLanguage, id, callback) {
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getFileState");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getFileState");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = FileState;
      return this.apiClient.callApi(
        '/files/{id}/state', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getImageState operation.
     * @callback module:api/StateApi~getImageStateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ImageState} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the state of Image resource.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} id 
     * @param {module:api/StateApi~getImageStateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ImageState}
     */
    getImageState(acceptLanguage, id, callback) {
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getImageState");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getImageState");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = ImageState;
      return this.apiClient.callApi(
        '/images/{id}/state', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getIngredientState operation.
     * @callback module:api/StateApi~getIngredientStateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/IngredientState} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the state of Ingredient resource.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} id 
     * @param {module:api/StateApi~getIngredientStateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/IngredientState}
     */
    getIngredientState(acceptLanguage, id, callback) {
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getIngredientState");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getIngredientState");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = IngredientState;
      return this.apiClient.callApi(
        '/ingredients/{id}/state', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getProductState operation.
     * @callback module:api/StateApi~getProductStateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProductState} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the state of Product resource.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} id 
     * @param {module:api/StateApi~getProductStateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProductState}
     */
    getProductState(acceptLanguage, id, callback) {
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getProductState");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getProductState");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = ProductState;
      return this.apiClient.callApi(
        '/products/{id}/state', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getRecipeState operation.
     * @callback module:api/StateApi~getRecipeStateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/RecipeState} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the state of Recipe resource.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} id 
     * @param {module:api/StateApi~getRecipeStateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/RecipeState}
     */
    getRecipeState(acceptLanguage, id, callback) {
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getRecipeState");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getRecipeState");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = RecipeState;
      return this.apiClient.callApi(
        '/recipes/{id}/state', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getTaxonState operation.
     * @callback module:api/StateApi~getTaxonStateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/TaxonState} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the state of Taxon resource.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} taxonomyName 
     * @param {String} id 
     * @param {module:api/StateApi~getTaxonStateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/TaxonState}
     */
    getTaxonState(acceptLanguage, taxonomyName, id, callback) {
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getTaxonState");
      }
      // verify the required parameter 'taxonomyName' is set
      if (taxonomyName === undefined || taxonomyName === null) {
        throw new Error("Missing the required parameter 'taxonomyName' when calling getTaxonState");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getTaxonState");
      }

      let pathParams = {
        'taxonomy_name': taxonomyName,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = TaxonState;
      return this.apiClient.callApi(
        '/taxonomies/{taxonomy_name}/taxons/{id}/state', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getVideoState operation.
     * @callback module:api/StateApi~getVideoStateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VideoState} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the state of Video resource.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} id 
     * @param {module:api/StateApi~getVideoStateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VideoState}
     */
    getVideoState(acceptLanguage, id, callback) {
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getVideoState");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getVideoState");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = VideoState;
      return this.apiClient.callApi(
        '/videos/{id}/state', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the setArticleState operation.
     * @callback module:api/StateApi~setArticleStateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ArticleState} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the state of Article resource.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} id 
     * @param {module:model/ArticleStateUpdate} article The updated Article resource
     * @param {module:api/StateApi~setArticleStateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ArticleState}
     */
    setArticleState(acceptLanguage, id, article, callback) {
      let postBody = article;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling setArticleState");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling setArticleState");
      }
      // verify the required parameter 'article' is set
      if (article === undefined || article === null) {
        throw new Error("Missing the required parameter 'article' when calling setArticleState");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = ArticleState;
      return this.apiClient.callApi(
        '/articles/{id}/state', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the setBrandState operation.
     * @callback module:api/StateApi~setBrandStateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BrandState} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the state of Brand resource.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} id 
     * @param {module:model/BrandStateUpdate} brand The updated Brand resource
     * @param {module:api/StateApi~setBrandStateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BrandState}
     */
    setBrandState(acceptLanguage, id, brand, callback) {
      let postBody = brand;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling setBrandState");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling setBrandState");
      }
      // verify the required parameter 'brand' is set
      if (brand === undefined || brand === null) {
        throw new Error("Missing the required parameter 'brand' when calling setBrandState");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = BrandState;
      return this.apiClient.callApi(
        '/brands/{id}/state', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the setFileState operation.
     * @callback module:api/StateApi~setFileStateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/FileState} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the state of File resource.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} id 
     * @param {module:model/FileStateUpdate} file The updated File resource
     * @param {Object} opts Optional parameters
     * @param {String} opts.filename Specifies the filename to be used for the 'upload' transition
     * @param {module:api/StateApi~setFileStateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/FileState}
     */
    setFileState(acceptLanguage, id, file, opts, callback) {
      opts = opts || {};
      let postBody = file;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling setFileState");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling setFileState");
      }
      // verify the required parameter 'file' is set
      if (file === undefined || file === null) {
        throw new Error("Missing the required parameter 'file' when calling setFileState");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
        'filename': opts['filename']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = FileState;
      return this.apiClient.callApi(
        '/files/{id}/state', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the setImageState operation.
     * @callback module:api/StateApi~setImageStateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ImageState} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the state of Image resource.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} id 
     * @param {module:model/ImageStateUpdate} image The updated Image resource
     * @param {module:api/StateApi~setImageStateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ImageState}
     */
    setImageState(acceptLanguage, id, image, callback) {
      let postBody = image;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling setImageState");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling setImageState");
      }
      // verify the required parameter 'image' is set
      if (image === undefined || image === null) {
        throw new Error("Missing the required parameter 'image' when calling setImageState");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = ImageState;
      return this.apiClient.callApi(
        '/images/{id}/state', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the setIngredientState operation.
     * @callback module:api/StateApi~setIngredientStateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/IngredientState} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the state of Ingredient resource.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} id 
     * @param {module:model/IngredientStateUpdate} ingredient The updated Ingredient resource
     * @param {module:api/StateApi~setIngredientStateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/IngredientState}
     */
    setIngredientState(acceptLanguage, id, ingredient, callback) {
      let postBody = ingredient;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling setIngredientState");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling setIngredientState");
      }
      // verify the required parameter 'ingredient' is set
      if (ingredient === undefined || ingredient === null) {
        throw new Error("Missing the required parameter 'ingredient' when calling setIngredientState");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = IngredientState;
      return this.apiClient.callApi(
        '/ingredients/{id}/state', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the setProductState operation.
     * @callback module:api/StateApi~setProductStateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProductState} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the state of Product resource.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} id 
     * @param {module:model/ProductStateUpdate} product The updated Product resource
     * @param {module:api/StateApi~setProductStateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProductState}
     */
    setProductState(acceptLanguage, id, product, callback) {
      let postBody = product;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling setProductState");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling setProductState");
      }
      // verify the required parameter 'product' is set
      if (product === undefined || product === null) {
        throw new Error("Missing the required parameter 'product' when calling setProductState");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = ProductState;
      return this.apiClient.callApi(
        '/products/{id}/state', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the setRecipeState operation.
     * @callback module:api/StateApi~setRecipeStateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/RecipeState} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the state of Recipe resource.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} id 
     * @param {module:model/RecipeStateUpdate} recipe The updated Recipe resource
     * @param {module:api/StateApi~setRecipeStateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/RecipeState}
     */
    setRecipeState(acceptLanguage, id, recipe, callback) {
      let postBody = recipe;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling setRecipeState");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling setRecipeState");
      }
      // verify the required parameter 'recipe' is set
      if (recipe === undefined || recipe === null) {
        throw new Error("Missing the required parameter 'recipe' when calling setRecipeState");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = RecipeState;
      return this.apiClient.callApi(
        '/recipes/{id}/state', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the setTaxonState operation.
     * @callback module:api/StateApi~setTaxonStateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/TaxonState} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the state of Taxon resource.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} taxonomyName 
     * @param {String} id 
     * @param {module:model/TaxonStateUpdate} taxon The updated Taxon resource
     * @param {module:api/StateApi~setTaxonStateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/TaxonState}
     */
    setTaxonState(acceptLanguage, taxonomyName, id, taxon, callback) {
      let postBody = taxon;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling setTaxonState");
      }
      // verify the required parameter 'taxonomyName' is set
      if (taxonomyName === undefined || taxonomyName === null) {
        throw new Error("Missing the required parameter 'taxonomyName' when calling setTaxonState");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling setTaxonState");
      }
      // verify the required parameter 'taxon' is set
      if (taxon === undefined || taxon === null) {
        throw new Error("Missing the required parameter 'taxon' when calling setTaxonState");
      }

      let pathParams = {
        'taxonomy_name': taxonomyName,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = TaxonState;
      return this.apiClient.callApi(
        '/taxonomies/{taxonomy_name}/taxons/{id}/state', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the setVideoState operation.
     * @callback module:api/StateApi~setVideoStateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VideoState} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the state of Video resource.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} id 
     * @param {module:model/VideoStateUpdate} video The updated Video resource
     * @param {module:api/StateApi~setVideoStateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VideoState}
     */
    setVideoState(acceptLanguage, id, video, callback) {
      let postBody = video;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling setVideoState");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling setVideoState");
      }
      // verify the required parameter 'video' is set
      if (video === undefined || video === null) {
        throw new Error("Missing the required parameter 'video' when calling setVideoState");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = VideoState;
      return this.apiClient.callApi(
        '/videos/{id}/state', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
